// A word-level diff in the calm palette (U5): added words underlined, removed words struck through
// and muted. No red or green; screen readers hear "added" and "removed".
import { useMemo } from "react";
import { wordDiff } from "@shared/wordDiff";

export function DiffView({ before, after }: { before: string; after: string }) {
  const parts = useMemo(() => wordDiff(before, after), [before, after]);
  return (
    <p
      data-testid="tone-diff"
      className="rounded-lg border border-line bg-bg px-3.5 py-3 text-[15px] leading-relaxed break-words whitespace-pre-wrap text-ink"
    >
      {parts.map((p, i) =>
        p.kind === "same" ? (
          <span key={i}>{p.text}</span>
        ) : p.kind === "added" ? (
          <ins
            key={i}
            data-diff="added"
            className="decoration-accent underline decoration-2 underline-offset-[3px]"
          >
            <span className="sr-only">added: </span>
            {p.text}
          </ins>
        ) : (
          <del key={i} data-diff="removed" className="text-muted line-through">
            <span className="sr-only">removed: </span>
            {p.text}
          </del>
        ),
      )}
    </p>
  );
}
